// extracted by mini-css-extract-plugin
module.exports = {"writing-section-page":"writing-section-page__b0Bxo"};